import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetCurrentAccountsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "current_accounts": [{
                    "current_account": {
                        "customer": {
                            "code": "123",
                            "fantasy_name": "Client123",
                            "business_name": "Client123BN123",
                            "number": "1234",
                            "taxpayer_identification_number": 123,
                            "delivery_sites": [
                                {
                                    "name": "DeliverySite123",
                                    "address": "Calle123",
                                    "city": "CABA"
                                },
                                {
                                    "name": "DeliverySite456",
                                    "address": "Calle456",
                                    "city": "CABA"
                                }
                            ]
                        },
                        "outstanding_balance": {
                            'amount': 10000.00,
                            'currency': "ARS"
                        },
                        "overdue_balance": {
                            'amount': 2500.00,
                            'currency': "ARS"
                        },
                        "unassigned_balance": {
                            'amount': 0.00,
                            'currency': "ARS"
                        },
                        "total_balance": {
                            'amount': 12500.00,
                            'currency': "ARS"
                        },
                        "has_no_overdue_tolerance": false
                    },
                    "channel": "HORECA",
                    "worst_tier": {"code": "31_to_90", "label": "+30 a 90"},
                    "has_order_with_future_delivery": true,
                    "has_overdue_invoices": true
                }, {
                    "current_account": {
                        "customer": {
                            "code": "456",
                            "fantasy_name": "Client456",
                            "business_name": "Client456BN456",
                            "number": "4567",
                            "taxpayer_identification_number": 456,
                            "delivery_sites": []
                        },
                        "outstanding_balance": {
                            'amount': 0.00,
                            'currency': "ARS"
                        },
                        "overdue_balance": {
                            'amount': 0.00,
                            'currency': "ARS"
                        },
                        "unassigned_balance": {
                            'amount': 0.00,
                            'currency': "ARS"
                        },
                        "total_balance": {
                            'amount': 0.00,
                            'currency': "ARS"
                        },
                        "has_no_overdue_tolerance": false
                    },
                    "channel": "Distribuidora",
                    "worst_tier": null,
                    "has_order_with_future_delivery": false,
                    "has_overdue_invoices": false
                }]
            },
            errors: []
        }
    }

    currentAccounts() {
        return this.content().current_accounts.map(portfolioRow => {
            return {
                customerCode: portfolioRow.current_account.customer.code,
                clientBusinessName: portfolioRow.current_account.customer.business_name,
                clientFantasyName: portfolioRow.current_account.customer.fantasy_name,
                outstandingBalance: portfolioRow.current_account.outstanding_balance,
                overdueBalance: portfolioRow.current_account.overdue_balance,
                unassignedBalance: portfolioRow.current_account.unassigned_balance,
                totalBalance: portfolioRow.current_account.total_balance,
                channel: portfolioRow.channel,
                worstTier: portfolioRow.worst_tier,
                hasOrderWithFutureDelivery: portfolioRow.has_order_with_future_delivery,
                hasNoOverdueTolerance: portfolioRow.current_account.has_no_overdue_tolerance,
                taxpayerIdentificationNumber: portfolioRow.current_account.customer.taxpayer_identification_number,
                hasOverdueInvoices: portfolioRow.has_overdue_invoices,
            }
        })
    }

}
